import { CenteredMenuHeaderComponent } from './centeredMenuHeader/centeredMenuHeader';
import { GameboardComponent } from './gameboard/gameboard';
import { TimerComponent } from './timer/timer';
import { DialogComponent } from './dialog/dialog';

export const ALL_COMPONENTS = [
    CenteredMenuHeaderComponent,
    GameboardComponent,
    TimerComponent,
    DialogComponent,
];
